import { ComponentProps, useCallback, useEffect } from 'react';
import { useApplicationType } from '../../common/hooks/use-application-type';
import {
    useDrawerControls,
    useDrawerRender,
} from '../../drawers/components/drawer-context-provider';
import { DrawerComponents, DrawerName, DrawerType } from '../../drawers/types';
import { useUnitAssignment } from '../../unit-assignment/unit-assignment-context';

export function useNavDrawers(
    drawerName: DrawerName,
    drawerProps: ComponentProps<DrawerComponents[DrawerName]> = {}
) {
    const drawerControls = useDrawerControls();
    const drawerRender = useDrawerRender();
    const unitAssignment = useUnitAssignment();
    const { isFirstResponder } = useApplicationType();

    const unitId = unitAssignment?.unitId;

    useEffect(
        function autoCloseUnitLocationDrawerIfThereIsNoUnitId() {
            if (isFirstResponder && !unitId && drawerRender?.drawer.type === 'unit-location') {
                drawerControls.close();
            }
        },
        [drawerControls, drawerRender, isFirstResponder, unitId]
    );

    const toggleDrawer = useCallback(() => {
        if (drawerRender?.drawer.type === drawerName) {
            drawerControls.close();
        } else {
            drawerControls.open({
                type: drawerName,
                inline: true,
                props: drawerProps,
            } as DrawerType<DrawerName>);
        }
    }, [drawerControls, drawerRender, drawerName, drawerProps]);

    return {
        isDrawerOpen: drawerRender?.drawer.type === drawerName,
        toggleDrawer,
    };
}
